'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function (_React$Component) {
  (0, _inherits3.default)(Button, _React$Component);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
  }

  (0, _createClass3.default)(Button, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./Button.scss');

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles['Button'], true), (0, _defineProperty3.default)(_classnames, styles['Button--primary'], this.props.primary), (0, _defineProperty3.default)(_classnames, styles['Button--secondary'], this.props.secondary), (0, _defineProperty3.default)(_classnames, styles['Button--small'], this.props.small), (0, _defineProperty3.default)(_classnames, styles['Button--fullWidth'], this.props.fullWidth), (0, _defineProperty3.default)(_classnames, styles['Button--lite'], this.props.lite), (0, _defineProperty3.default)(_classnames, styles['Button--fat'], this.props.fat), _classnames));
      classes = classes.concat(" " + (this.props.className || ""));

      var attrs = {};
      if (this.props.style) attrs.style = this.props.style;
      if (this.props.form) attrs.form = this.props.form;
      if (this.props.onMouseEnter) attrs.onMouseEnter = this.props.onMouseEnter;
      if (this.props.onMouseLeave) attrs.onMouseLeave = this.props.onMouseLeave;
      if (this.props.onClick) attrs.onClick = this.props.onClick;
      if (this.props.tabIndex) attrs.tabIndex = this.props.tabIndex;
      if (this.props.disabled) attrs.disabled = this.props.disabled;
      if (this.props.type) attrs.type = this.props.type;

      return this.props.link ? this.props.to ? _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({ to: this.props.to, className: classes }, attrs),
        this.props.label
      ) : _react2.default.createElement(
        'a',
        (0, _extends3.default)({ href: this.props.href, className: classes }, attrs),
        this.props.label
      ) : _react2.default.createElement(
        'button',
        (0, _extends3.default)({ className: classes }, attrs),
        this.props.label
      );
    }
  }]);
  return Button;
}(_react2.default.Component);

Button.propTypes = {
  label: _react2.default.PropTypes.string.isRequired,
  className: _react2.default.PropTypes.string,
  form: _react2.default.PropTypes.string,
  disabled: _react2.default.PropTypes.bool,
  primary: _react2.default.PropTypes.bool,
  secondary: _react2.default.PropTypes.bool,
  small: _react2.default.PropTypes.bool,
  fullWidth: _react2.default.PropTypes.bool,
  lite: _react2.default.PropTypes.bool,
  fat: _react2.default.PropTypes.bool,
  link: _react2.default.PropTypes.bool,
  href: _react2.default.PropTypes.string,
  type: _react2.default.PropTypes.string,
  to: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object]),
  tabIndex: _react2.default.PropTypes.string,
  onClick: _react2.default.PropTypes.func
};

exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.jsx
// module id = 2302
// module chunks = 0